import { format, parseISO } from 'date-fns';

import { RosterRequestQuery, RosterRoomAssignment } from 'generated/graphql';

type AssignmentChangesProps = {
  requestData: RosterRequestQuery['rosterRequest']['requestData'];
  assignment: RosterRoomAssignment;
};

const AssignmentChanges = ({
  requestData,
  assignment,
}: AssignmentChangesProps) => {
  if (requestData?.__typename !== 'RosterRequestDataDateChange') {
    return null;
  }

  return (
    <>
      <div className="mb-5">
        <div className="rounded-md border border-red-200 bg-red-50 p-5">
          <h2 className="mb-5 text-sm text-primaryGray">Current Assignment</h2>
          {assignment.checkInDate && (
            <p className="text-sm">
              Check In: {format(parseISO(assignment.checkInDate), 'MM/dd/yyyy')}
            </p>
          )}
          {assignment.checkOutDate && (
            <p className="text-sm">
              Check Out:{' '}
              {format(parseISO(assignment.checkOutDate), 'MM/dd/yyyy')}
            </p>
          )}
        </div>
      </div>
      <div className="mb-5">
        <div className="rounded-md border border-blue-200 bg-blue-50 p-5">
          <h2 className="mb-5 text-sm text-primaryGray">Requested Changes</h2>
          {requestData?.checkInDate && (
            <p className="text-sm">
              Check In:{' '}
              {format(parseISO(requestData.checkInDate), 'MM/dd/yyyy')}
            </p>
          )}
          {requestData?.checkOutDate && (
            <p className="text-sm">
              Check Out:{' '}
              {format(parseISO(requestData.checkOutDate), 'MM/dd/yyyy')}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default AssignmentChanges;
